import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import {
  CustomerInfoAllApiResult,
  FamilyStructureInfo,
  NegotiationInfoDetail,
  ActionInfoDetail,
  ProductInfoDetail,
  ProductStatusInfoPreview,
  ProductVariableInfoPreview,
  QuotationPdf,
  AttachedFile,
} from '../../../external/CustomerInfoAllApi';

type CustomerInfoAllResultStateBase = Omit<
  CustomerInfoAllApiResult,
  'familyStructureInfoList' | 'negotiationInfoDetail' | 'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'
>;

export type FamilyStructureInfoState = FamilyStructureInfo;

type NegotiationInfoDetailStateBase = Omit<
  NegotiationInfoDetail,
  | 'attachedFileList'
  | 'quotationPdf'
  | 'productInfoDetail'
  | 'actionInfoDetail'
  | 'createUser'
  | 'createDateTime'
  | 'updateUser'
  | 'updateDateTime'
>;

type ProductInfoDetailStateBase = Omit<
  ProductInfoDetail,
  'productStatusInfo' | 'productVariableInfo' | 'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'
>;

export type ProductStatusInfoPreviewState = Omit<
  ProductStatusInfoPreview,
  'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'
>;

export type ProductVariableInfoPreviewState = Omit<
  ProductVariableInfoPreview,
  'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'
>;

export type ActionInfoDetailState = Omit<ActionInfoDetail, 'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'>;

export interface ProductInfoDetailState extends ProductInfoDetailStateBase {
  productStatusInfo: ProductStatusInfoPreviewState;
  productVariableInfo: ProductVariableInfoPreviewState[];
}

export type AttachedFileState = Omit<AttachedFile, 'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'>;
export type QuotationPdfState = Omit<QuotationPdf, 'createUser' | 'createDateTime' | 'updateUser' | 'updateDateTime'>;
export interface NegotiationInfoDetailState extends NegotiationInfoDetailStateBase {
  attachedFileList: AttachedFileState[];
  quotationPdf: QuotationPdfState | null;
  productInfoDetail: ProductInfoDetailState[];
  actionInfoDetail: ActionInfoDetailState[];
}
export interface CustomerInfoAllState extends CustomerInfoAllResultStateBase {
  negotiationInfoDetail: NegotiationInfoDetailState[];
  familyStructureInfoList: FamilyStructureInfoState[];
}

const initialState: CustomerInfoAllState = {
  customerId: 0,
  customerNumber: '',
  sendMailType: '',
  customerNameType: null,
  customerFullName: null,
  customerKanaFullName: null,
  contactMsn1: null,
  msnUpdDate: null,
  contactMsn2: null,
  familyStructureType: null,
  familyStructureInfoList: [],
  familyStructureAge: null,
  familyStructureAgeCount: null,
  mailPermissionType: null,
  sendMailMsnType: null,
  sendMailAddress: null,
  permissionType: null,
  sendRegulationType: null,
  docType: null,
  stayDeadline: null,
  otherInput: null,
  otherDocTypeConsent: null,
  otherDocTypeCommission: null,
  otherDocTypeAddress: null,
  otherDocTypeFamily: null,
  brandType: null,
  slipReceiptNum: null,
  sbbStartDate: null,
  sbhikariApplActCd: null,
  negotiationInfoDetail: [],
  ginieReceptionContents: [],
  bswReceptionContents: [],
};

export const CustomerInfoAllReducer = reducerWithInitialState(initialState)
  .case(actions.fetchCustomerInfoAll.init, () => {
    return initialState;
  })
  .case(actions.fetchCustomerInfoAll.fetch, (state: CustomerInfoAllState, payload: CustomerInfoAllState) => {
    return {
      ...state,
      ...payload,
    };
  });
